import styled from 'styled-components'

export const Input = styled.input`
  -webkit-appearance: none;
  flex-grow: 1;
  background: ${({ theme }) => theme.colors.neutralW30};
  height: 4px;
  border-radius: 5px;
  background-image: ${({ theme }) =>
    `linear-gradient(${theme.colors.player50}, ${theme.colors.player50})`};
  background-size: 0% 100%;
  background-repeat: no-repeat;

  /* Input Thumb */
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: ${({ theme, disabled }) =>
      disabled ? theme.colors.neutralW40 : theme.colors.neutralW100};
    cursor: pointer;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }

  &::-moz-range-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: ${({ theme, disabled }) =>
      disabled ? theme.colors.neutralW40 : theme.colors.neutralW100};
    cursor: pointer;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }

  &::-ms-thumb {
    -webkit-appearance: none;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: ${({ theme, disabled }) =>
      disabled ? theme.colors.neutralW40 : theme.colors.neutralW100};
    cursor: pointer;
    box-shadow: 0 0 2px 0 #555;
    transition: background 0.3s ease-in-out;
  }

  /* Input Track */
  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  &::-moz-range-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  &::-ms-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }
`
